<script setup lang="ts">
  import type { RouteLocationRaw } from 'vue-router'

  interface Props {
    to?: RouteLocationRaw,
    loading?: boolean,
    disabled?: boolean,
    type?: 'submit' | 'reset' | 'button',
  }
  defineProps<Props>()
</script>

<template>
  <button
    v-if="!to || loading || disabled"
    :type="type"
    :disabled="disabled || loading"
    :class="{ loading: loading }"
    class="btn">
    <slot></slot>
  </button>
  <router-link
    v-else
    :to="to"
    class="btn">
    <slot></slot>
  </router-link>
</template>

<style lang="postcss" scoped>
  .btn {
    @apply inline-block whitespace-nowrap border px-4 py-2 text-sm;
    &:disabled {
      @apply cursor-not-allowed border-gray-100 bg-gray-100 text-gray-500;
    }
  }
  .btn-primary {
    @apply border-primary-500 bg-primary-500 text-gray-50;
  }
  .btn-outline-primary {
    @apply border-primary-500 bg-white text-primary-500;
  }
  .btn-red {
    @apply border-red-500 bg-red-500 text-white;
  }
  .btn-outline-red {
    @apply border-red-500 bg-white text-red-500;
  }
  .btn-gray {
    @apply border-gray-500 bg-gray-500 text-white;
  }
</style>
